import { QueryApiFactoryService } from 'app/apis/query-api.factory.service';
import { LoggerService } from 'app/logger/logger.service';
import { DatasetFormatType } from 'app/model/dataflow/dataset-settings/dataflow-dataset-settings';
import { LinkedService } from 'shell-models-lib';

export const supportedSqlDatasetFormatToDatasetSettingMap: Map<DatasetFormatType, string> = new Map([
    [DatasetFormatType.SqlDB, 'SqlDBSettings'],
    [DatasetFormatType.SqlMI, 'SqlMISettings'],
    [DatasetFormatType.OnPremiseSqlServer, 'OnPremiseSqlServerSettings']
]);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function fetchEntitiesForSQLBasedEntity(queryApiFactoryService: QueryApiFactoryService, linkedService: LinkedService, datasetType: string, loggerService: LoggerService): Promise<any[]> {

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const mergedTableNames: any[] = [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let nativecdcTableNames: any[] = [];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let watermarkFilteredTableNames: any[] = [];
        try {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            nativecdcTableNames = await queryApiFactoryService.getWizardQueryApi().queryDataset<any[]>({
                    linkedService,
                    query: 'execute sys.sp_cdc_help_change_data_capture',
                    datasetType,
                });
        } catch (error) {
            // error thrown in case cdc is not enabled
            loggerService.log('ADFCDC',`Error while fetching native CDC enabled tables : ${error}`);
        }
        try {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            watermarkFilteredTableNames = await queryApiFactoryService.getWizardQueryApi().queryDataset<any[]>({
                    linkedService,
                    query: `SELECT TABLE_SCHEMA, TABLE_NAME, COLUMN_NAME, DATA_TYPE FROM INFORMATION_SCHEMA.COLUMNS WHERE (DATA_TYPE LIKE '%date%' OR DATA_TYPE LIKE '%time') AND TABLE_SCHEMA not in ('sys', 'cdc')`,
                    datasetType,
                });
        } catch (error) {
            // error thrown in case watermark query fails
            loggerService.log('ADFCDC',`Error while fetching tables with incremental columns : ${error}`);
        }

        nativecdcTableNames.forEach((table) => {
            if (table.supports_net_changes) {
                table.name = `${table?.source_schema || ''}.${table.source_table}`;
                table.isNativeCDC = true;
                const tab = mergedTableNames.find((newtab) => newtab.name === table.name);
                if(!tab) {
                    // avoid duplicate table entries as ADF CDC supports only single capture instance
                    mergedTableNames.push(table);
                }
            }
         });

         watermarkFilteredTableNames.forEach((table) => {
            table.name = `${table?.TABLE_SCHEMA || ''}.${table.TABLE_NAME}`;
            const dataType = table.DATA_TYPE;
            if(dataType !== 'datetimeoffset'){
                const tab = mergedTableNames.find((newtab) => newtab.name === table.name);

                if (!tab) {
                    table.name = `${table?.TABLE_SCHEMA || ''}.${table.TABLE_NAME}`;
                    table.watermarkCols = [];
                    table.watermarkCols.push(table.COLUMN_NAME);
                    mergedTableNames.push(table);
                } else if (!!tab.watermarkCols) {
                    tab.watermarkCols.push(table.COLUMN_NAME);
                }
            }
         });

    return mergedTableNames;
}

